import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import userIcon from "../../images/user-icon.svg";
import useUserState from "../hooks/useUserState";
import Axios from "axios";
import VaccinesDialog from "./VaccinesDialog";
import useBDocTranslator from "../hooks/useBDocTranslator";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "whitesmoke",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "900px",
    height: "400px",
  },
}));

export default function VaccinesModalForm(props) {
  const classes = useStyles();
  const [responseMessage, setResponseMessage] = useState("");
  const userLocalState = useUserState();
  const [successFlag, setSuccessFlag] = useState(false);
  const { t } = useBDocTranslator();

  //Method creates a dependant
  const handleVaccinesCreate = (data) => {
    if (!validateData(data)) {
      setResponseMessage("Error, Please fill the Form");
      return;
    }

    Axios.post(`${process.env.REACT_APP_API_URL_BASE}/ehr/create`, data, {
      headers: { Authorization: "Bearer " + userLocalState[0].jwt },
    })
      .then((response) => {
        setSuccessFlag(true);
        setResponseMessage("Vaccine created, EHR Updated");
        props.handleRefreshData();
      })
      .catch((error) => {
        console.log(error);
        setResponseMessage(error);
      });
  };

  // validate the data object if it is valid
  const validateData = (data) => {
    if (data.name === "") {
      return false;
    }
    if (data.application_date === "") {
      return false;
    }
    if (data.dose < 1) {
      return false;
    }
    if (data.batch === "") {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {
            <div className={classes.paper}>
              <div className="row col-md-12">
                <div className="col-md-4">
                  <img src={userIcon} alt="rx icon" className="w-30-custom" />
                </div>
                <div className="col-md-8">
                  <h3>{t("Include Vaccines")}</h3>
                </div>
                <div className="col-md-12">
                  <p
                    className={`font-weight-bold  ${
                      responseMessage.includes("Error")
                        ? "text-danger"
                        : "text-success"
                    } text-center`}
                  >
                    {t(responseMessage)}
                  </p>
                </div>
              </div>
              {/* Form */}
              <div className="row col-md-12">
                <VaccinesDialog
                  handleVaccinesCreate={handleVaccinesCreate}
                  // prescriptionValue={notes}
                  // handleSave={handlePrescriptionSave}
                  handleClose={props.handleClose}
                  successFlag={successFlag}
                  patientId={props.patientId}
                />
              </div>
            </div>
          }
        </Fade>
      </Modal>
    </div>
  );
}
